import { render, staticRenderFns } from "./AvisoPrivacidad.vue?vue&type=template&id=7e58455a&scoped=true"
import script from "./AvisoPrivacidad.vue?vue&type=script&lang=js"
export * from "./AvisoPrivacidad.vue?vue&type=script&lang=js"
import style0 from "./AvisoPrivacidad.vue?vue&type=style&index=0&id=7e58455a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e58455a",
  null
  
)

export default component.exports